import { useGetScheduledJobsQuery } from "@/hooks/queries/useGetScheduledJobsQuery";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from "../ui/select";
import Icon from "../common/Icon";
import { useState } from "react";
import { Loader2, Search } from "lucide-react";
import Text from "../common/Text";
import { Input } from "../ui/input";
import { useDebounceValue } from "usehooks-ts";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";
interface AnalyticsCriteriaProps {
  selectedJobId: string | null;
  onJobSelect: (jobId: string) => void;
}
export default function AnalyticsCriteria({
  selectedJobId,
  onJobSelect,
}: AnalyticsCriteriaProps) {
  const { sendEvent } = useAnalyticsManager();
  const [search, setSearch] = useState("");
  const [debouncedSearchValue] = useDebounceValue(search, 500);
  const { data: jobs, isLoading } = useGetScheduledJobsQuery(
    100,
    debouncedSearchValue
  );
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation(); // Prevent event bubbling
    setSearch(e.target.value);
  };

  const handleJobSelect = (jobId: string) => {
    onJobSelect(jobId);
  };

  return (
    <div className="flex gap-4">
      <Select value={selectedJobId ?? ""} onValueChange={handleJobSelect}>
        <SelectTrigger
          onClick={() => {
            sendEvent("select_job_clicked", {
              job_id: selectedJobId ?? "",
            });
          }}
          className="flex w-fit items-center justify-center gap-2 rounded-none border border-brand-border bg-transparent font-mono text-[11px] uppercase tracking-[0.22em] text-brand-text text-brand-text"
        >
          <Icon name="insightsNavbar" size={16} />
          <span>Select Dataset</span>
        </SelectTrigger>
        <SelectContent>
          <div className="flex items-center gap-2 px-3 py-2">
            <Search className="h-4 w-4 text-gray-400" />
            <Input
              placeholder="Search datasets..."
              value={search}
              onChange={handleSearchChange}
              className="h-8 border-none focus-visible:ring-0 focus-visible:ring-offset-0"
              onKeyDown={(e) => e.stopPropagation()} // Prevent select keyboard navigation
            />
          </div>
          <SelectGroup>
            {isLoading ? (
              <div className="flex items-center justify-center gap-2 py-2">
                <Loader2 size={16} className="animate-spin" color="#878A92" />
                <Text
                  variant={"paragraph_p6"}
                  className="text-shades-neutral-200"
                >
                  Loading
                </Text>
              </div>
            ) : jobs?.pages[0]?.data?.length ? (
              jobs?.pages
                .flatMap((page) => page.data)
                .map((job) => (
                  <SelectItem key={job.id} value={job.id.toString()}>
                    {job.jobName}
                  </SelectItem>
                ))
            ) : (
              <div className="flex items-center justify-center py-2">
                <Text
                  variant={"paragraph_p6"}
                  className="text-shades-neutral-200"
                >
                  No jobs found
                </Text>
              </div>
            )}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
